import store from '@/store';
import useCurrency from '@/utils/useCurrency';
import axios from 'axios';

const instance = axios.create({
	baseURL: process.env.VUE_APP_API,
	withCredentials: true,
	timeout: 25000,

	headers: {
		'Content-Type': 'application/json',
	},
});

instance.interceptors.request.use(
	(config) => {
		const languageId = store.getters['app/currentLanguage'];
		const currency = useCurrency().getCurrencyCode();

		const excludedUrls = ['/items/list'];

		if (!excludedUrls.includes(config.url)) {
			if (config.method === 'get') {
				config.params = {
					...config.params,
					currency,
					lang_id: languageId,
				};
			}

			if (['post', 'put', 'patch'].includes(config.method)) {
				config.data = {
					...config.data,
					currency,
					lang_id: languageId,
				};
			}
		}

		return config;
	},
	(error) => Promise.reject(error),
);

/**
 * CSRF: бэк отдаёт токен на GET /csrf-token, дальше шлём его заголовком
 * X-CSRF-TOKEN. Кука сессии живёт 2 часа, поэтому на 419 (Page Expired)
 * забираем токен заново и повторяем запрос один раз.
 */
let csrfToken = '';
let csrfRequest = null;

export const fetchCsrfToken = (force = false) => {
	if (csrfToken && !force) {
		return Promise.resolve(csrfToken);
	}

	if (!csrfRequest) {
		csrfRequest = instance
			.get('csrf-token')
			.then(({ data }) => {
				csrfToken = (data && data.token) || '';
				return csrfToken;
			})
			.catch(() => '')
			.finally(() => {
				csrfRequest = null;
			});
	}

	return csrfRequest;
};

instance.interceptors.request.use((config) => {
	if (csrfToken && ['post', 'put', 'patch', 'delete'].includes(config.method)) {
		config.headers['X-CSRF-TOKEN'] = csrfToken;
	}

	return config;
});

instance.interceptors.response.use(
	(response) => response,
	async (error) => {
		const config = error.config;

		if (error.response?.status === 419 && config && !config._csrfRetry) {
			config._csrfRetry = true;
			const token = await fetchCsrfToken(true);

			if (token) {
				config.headers['X-CSRF-TOKEN'] = token;
				return instance.request(config);
			}
		}

		return Promise.reject(error);
	},
);

instance.interceptors.response.use(
	(response) => response,
	(error) => {
		console.error(
			'[API error]',
			error.config?.method?.toUpperCase(),
			error.config?.url,
			error.response?.status,
			error.response?.data,
		);

		return Promise.reject(error);
	},
);

export default instance;
